export const vehicleSizes = [
  { name: "Small", value: "SMALL", label: "Small" },
  { name: "Medium", value: "MEDIUM", label: "Medium" },
  { name: "Large", value: "LARGE", label: "Large" },
  { name: "I don´t know", value: null, label: "I don´t know" }
];
export const vehicleTypes = [
  { name: "Petrol", value: "PETROL", label: "Petrol" },
  { name: "Diesel", value: "DIESEL", label: "Diesel" },
  { name: "Electric", value: "ELECTRIC", label: "Electric" },
  { name: "Hybrid", value: "HEV", label: "Hybrid" },
  { name: "Plug-in Hybrid", value: "PHEV", label: "Plug-in Hybrid" },
  { name: "I don´t know", value: null, label: "I don´t know" },
];
export const publicTransportTypes = [
  { name: "Bus", value: "BUS", label: "Bus" },
  { name: "Train", value: "TRAIN", label: "Train/Metro" },
  { name: "Ferry", value: "FERRY", label: "Ferry" }
];
export const motorbikeTypes = [
  { name: "Scooter", value: "SCOOTER", label: "Scooter" },
  { name: "Motorbike", value: "MOTORBIKE", label: "Motorbike" }
];
export const motorbikeVehicleTypes = [
  { name: "Petrol", value: "PETROL", label: "Petrol" },
  { name: "Electric", value: "ELECTRIC", label: "Electric" }
];
export const airportsClasses = [
  { name: "Economy", value: "ECONOMY", label: "Economy" },
  { name: "Business", value: "BUSINESS", label: "Business" },
  { name: "First Class", value: "FIRST", label: "First Class" }
];

export const defaultValues = {
  flights: {
    values: [{ origin: "", destination: "" }],
    origin: "",
    destination: "",
    cabinClass: airportsClasses[0],
    passengers: 1,
    duration: 1,
    errorMessage: '',
  },
  car: {
    origin: "",
    destination: "",
    distance: 0,
    vehicleSize: vehicleSizes[0],
    vehicleType: vehicleTypes[0],
    duration: 1
  },
  publicTransport: {
    origin: "",
    destination: "",
    distance: 0,
    transportType: publicTransportTypes[0],
    duration: 1
  },
  motorbike: {
    origin: "",
    destination: "",
    distance: 0,
    motorbikeType: motorbikeTypes[0],
    vehicleType: motorbikeVehicleTypes[0],
    duration: 1
  },
};
